export default "__VITE_ASSET__Baq68$1u__"